import React, { useState } from 'react';

// project imports
import { useGalleryContext } from '../../../context/gallery_context';
import VideoContentWidgetV2 from './VideoContentWidgetV2';
import ErrorComponent from '../../error-message/ErrorComponent';


function ReusableWidget({ data, classes, title, href, onVideoToggle, onOpenDrawer }) {
    // Extracting variables from context
    const { isLoading, isError } = useGalleryContext();

    return (
        <>
            {data && data?.length ?

                <div className={classes}>
                    <div className="row y-gap-15">
                        <div className="col-12">
                            <div className="rounded-16 edu-breadcrumb-area h-100">
                                <div class="d-flex justify-content-between align-items-center py-3 px-4 border-bottom-1">
                                    <h2 class="fs-17 fw-500 mb-0">{title}</h2>
                                    <a
                                        class="fs-14 color-primary text-decoration-underline"
                                        target="_blank"
                                        rel="noreferrer"
                                        href={href}
                                    >
                                        View All
                                    </a>
                                </div>
                                <div className="px-4 py-4">
                                    {!isLoading && isError ?
                                        <div className="row g-5 mt--10 text-center">
                                            <ErrorComponent errorCode="500" mainError={`No ${title} are available!`} subText={`Currently no ${title} are available. Please be back later.`} buttonText="Back to Home" link='/' />
                                        </div>
                                        :
                                        (!isLoading && !isError && data && !data.length) ?
                                            // <ErrorComponent errorCode="404" mainError="Oops...! No Courses are available." />
                                            <ErrorComponent errorCode="404" mainError={`Failed to get ${title} right now.`} subText="Please return to the site's homepage, It looks like nothing was found at this location" buttonText="Back to Home" link='/' />
                                            :
                                            <>
                                                <div>
                                                    {(data || []).slice(0, 3).map((item, index) => (
                                                        <div key={index}>
                                                            <VideoContentWidgetV2
                                                                data={item}
                                                                onVideoToggle={onVideoToggle}
                                                                onOpenDrawer={onOpenDrawer}
                                                                classes="border-bottom-1 "
                                                            />
                                                        </div>
                                                    ))}
                                                </div>

                                            </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                :
                <></>
            }
        </>
    )
}

export default ReusableWidget;
